import React from 'react';

/** Header shown at the top of each control panel (e.g. "MoneyBox Components"). */
export const sectionHeaderStyle: React.CSSProperties = { marginTop: 0, marginBottom: '1rem' };
